import React, {useState} from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import ScienceIcon from "@mui/icons-material/Science";
import FactoryIcon from "@mui/icons-material/Factory";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import GavelIcon from "@mui/icons-material/Gavel";
import MapIcon from "@mui/icons-material/Map";
import KazakhstanMap from "../Map";
import { kazakhstanRegions } from "../../../model/regions";

const CoalChemistryPage: React.FC = () => {
    const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
    const [hoveredRegion, setHoveredRegion] = useState<string | null>(null);


    const handleRegionClick = (region: any) => {
        setSelectedRegion(region.name);
        console.log('Выбран регион:', region);
    };

    const handleRegionHover = (region: any) => {
        setHoveredRegion(region ? region.name : null);
    };
    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            {/* Заголовок */}
            <Typography variant="h4" fontWeight={700} gutterBottom>
                Углехимия
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Стратегическое направление глубокой переработки угля и диверсификации экономики Казахстана
            </Typography>

            {/* Потенциал отрасли */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Потенциал развития углехимического кластера
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <List>
                            <ListItem>
                                <ListItemIcon><PublicIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Казахстан входит в топ-10 стран мира по запасам угля" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><ScienceIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Углехимия — приоритетное направление индустриализации 4.0" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><FactoryIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Производство синтез-газа, метанола, карбамида, технического углерода, активированного угля" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><TrendingUpIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Использование угля в химии вместо сжигания повышает добавленную стоимость в 10 раз" />
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                width: '100%',
                                backgroundColor: '#e3f2fd',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 2,
                                color: '#1976d2',
                                fontWeight: 600,
                            }}
                        >
                            <KazakhstanMap
                                regions={kazakhstanRegions}
                                onRegionClick={handleRegionClick}
                                onRegionHover={handleRegionHover}
                                defaultFill="#5764f7"
                                hoverFill="#4254f5"
                                activeFill="#3244d0"
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {/* Ключевые показатели */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Ключевые показатели отрасли (2024, фактические и прогнозные)
                </Typography>
                <Grid container spacing={2}>
                    {[
                        { label: 'Запасы угля', value: '33,6 млрд тонн' },
                        { label: 'Глубокая переработка', value: '18,7 млн тонн' },
                        { label: 'Инвестиции в углехимию', value: '276 млрд ₸' },
                        { label: 'Производство техуглерода', value: '112 тыс. тонн' },
                        { label: 'Экспорт продукции', value: '$1,4 млрд' },
                        { label: 'Доля в обрабатывающей промышленности', value: '6,1%' },
                    ].map((item, idx) => (
                        <Grid item xs={12} sm={6} md={4} key={idx}>
                            <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
                                <Typography variant="h6" fontWeight={700}>
                                    {item.value}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {item.label}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Paper>

            {/* Инвестиционные возможности */}
            <Paper sx={{ p: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Инвестиционные возможности
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><GavelIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Поддержка углехимических проектов в рамках Госпрограммы индустриализации" />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><MonetizationOnIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Налоговые льготы и доступ к инфраструктуре через СЭЗ «Сарыарка» и «Павлодар»" />
                        </ListItem>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ListItem disablePadding>
                            <ListItemIcon><MapIcon color="primary" /></ListItemIcon>
                            <ListItemText primary="Финансирование от Kazakh Invest, БРК, Samruk-Kazyna" />
                        </ListItem>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
};

export default CoalChemistryPage;